<template>
  <component v-bind:is="components[quoteMode]" :hub="hub" />
</template>
<script>
import MileageComplex from "@/default/pages/base_rates/modes/mileage_complex.vue";
import MileageSimple from "@/default/pages/base_rates/modes/mileage_simple.vue";
import CityFixed from "@/default/pages/base_rates/modes/city_fixed.vue";
export default {
  name: "BaseRateHub",
  components: { MileageComplex, MileageSimple, CityFixed },
  props: ["hub"],
  data() {
    return {
      components: {
        mileage_complex: MileageComplex,
        mileage_simple: MileageSimple,
        city_fixed: CityFixed,
      },
    };
  },
  computed: {
    quoteMode() {
      return this.hub.quote_mode;
    },
  },
};
</script>
